import React from 'react';
import clsx from 'clsx';
import {local} from '../../../Context/Local';
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import FavoriteIcon from '@material-ui/icons/Favorite';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ShopIcon from '@material-ui/icons/Shop';
import MarkunreadMailboxIcon from '@material-ui/icons/MarkunreadMailbox';
import ShopTwoIcon from '@material-ui/icons/ShopTwo';
import AccountBalanceWalletRoundedIcon from '@material-ui/icons/AccountBalanceWalletRounded';
import {useStyleC} from '../st/UseStyle';
// csG
import {style} from '../st/cStyle'
import Icons from './Icons';

export default function CardN({title}) {
  const classes = useStyleC();
  const [expanded, setExpanded] = React.useState(false);
  let his = useHistory();
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const dept = (i) => {
    his.push({
      pathname: '/depts',
      state: { local:local[i], },
    })
  };

  return (
    <Card className={classes.root}>
      <CardActionArea onClick={()=>dept(2)}>
      <CardMedia className={classes.media} title="" >
         <AccountBalanceWalletRoundedIcon className={classes.iconCard} style={style.color.safe}/>
      </CardMedia>

      <CardContent className={classes.content} style={style.color.safe}>
        <Typography variant="h5">
        {title}
        </Typography>
      </CardContent>
      </CardActionArea>
      <CardActions disableSpacing className={classes.actions}>
         {/* <IconButton aria-label="add to favorites"> <FavoriteIcon /> </IconButton> */}
        {/* <IconButton aria-label="share"> <ShareIcon /></IconButton> */}
        {/* <IconButton
          className={clsx(classes.expand, {
            [classes.expandOpen]: expanded,
          })}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon />
        </IconButton> */}
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className={classes.slidcontent}>
          {/* <Typography > */}
            {/*  */}
          {/* </Typography> */}

          {/* <Typography > */}
          <Icons/> 
          {/* </Typography> */}
        </CardContent>
      </Collapse>
    </Card>
  );
}

